import * as z from "zod";
import { number, string } from "zod";
export const ConfirmAddToCart = z.object({
  productId: number(),
  variantId: number(),
  quantity: number(),
  productTitle: string(),
});
